import * as React from 'react'
import { cn } from 'lib/utils'

export interface SwitchProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {}

const Switch = React.forwardRef<HTMLInputElement, SwitchProps>(({ className, ...props }, ref) => (
	<label className="relative inline-flex items-center cursor-pointer">
		<input type="checkbox" className="sr-only peer" ref={ref} {...props} />
		<div
			className={cn(
				'w-9 h-5 bg-input rounded-full peer peer-focus-visible:ring-2 peer-focus-visible:ring-ring peer-checked:bg-primary transition-colors after:content-[""] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:after:translate-x-full peer-disabled:opacity-50 peer-disabled:cursor-not-allowed',
				className,
			)}
		/>
	</label>
))
Switch.displayName = 'Switch'

export { Switch }
